import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { Constants } from "../interfaces/constants";
import { DetailsComponent } from "./details/details.component";
import { EditMetadataComponent } from "./edit-metadata/edit-metadata.component";
import { EditStepComponent } from "./edit-step/edit-step.component";
import { EditTemplateComponent } from "./edit/edit.component";
import { MyTemplatesComponent } from "./my-templates/my-templates.component";
import { NewMetadataComponent } from "./new-metadata/new-metadata.component";
import { NewStepComponent } from "./new-step/new-step.component";
import { NewComponent } from "./new/new.component";
import { MsalGuard } from "@azure/msal-angular";

const routes: Routes = [
  {
    path: "templates",
    children: [
      { path: "", pathMatch: "full", component: MyTemplatesComponent },
      { path: "new", component: NewComponent },
      {
        path: "edit",
        children: [
          {
            path: `:${Constants.routeParams.templateId}`,
            component: EditTemplateComponent
          }
        ]
      },
      {
        path: `:${Constants.routeParams.templateId}`,
        children: [
          {
            path: "",
            pathMatch: "full",
            component: DetailsComponent
          },
          {
            path: "meta",
            children: [
              {
                path: "new",
                component: NewMetadataComponent
              },
              { path: ":key", component: EditMetadataComponent }
            ]
          },
          {
            path: "step",
            children: [
              { path: "new", component: NewStepComponent },
              { path: ":stepId", component: EditStepComponent }
            ]
          }
        ]
      }
    ],
    canActivate: [MsalGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TemplatesRoutingModule { }
